import { Paper } from '@mantine/core';

import classes from './paper.module.css';

export const PaperOverride = Paper.extend({
  classNames: classes,
  defaultProps: { withBorder: true },
});
